import React from "react";
import { Link } from "react-router-dom";
import { MapPin, ArrowUpRight } from "lucide-react";
import Reveal from "./Reveal";
import { HOME_SEO, KEY_CITIES } from "../../cityLocal";
import { slugify } from "../../mock";

export function HomeSeo() {
  return (
    <section className="py-20" data-testid="home-seo">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-12 gap-12">
        <Reveal className="lg:col-span-6 space-y-5 text-[17px] text-[#4a5249] leading-relaxed">
          <h2 className="font-logo font-black tracking-[-0.025em] text-3xl lg:text-4xl text-[#13261c] leading-tight">{HOME_SEO.title}</h2>
          {HOME_SEO.paragraphs.map((p, i) => <p key={i}>{p}</p>)}
        </Reveal>
        <Reveal delay={100} className="lg:col-span-6">
          <h2 className="font-logo font-black tracking-[-0.025em] text-2xl text-[#13261c]">Nos conciergeries par ville</h2>
          <ul className="mt-5 grid sm:grid-cols-2 gap-2">
            {KEY_CITIES.map((c) => (
              <li key={c}>
                <Link to={`/villes/${slugify(c)}`} data-testid={`home-city-link-${slugify(c)}`} className="group flex items-center justify-between rounded-2xl bg-white ring-1 ring-[#e6dcc8] px-4 py-3 font-semibold text-[#13261c] hover:bg-[#13261c] hover:text-white transition-colors">
                  <span className="flex items-center gap-2 min-w-0"><MapPin className="w-4 h-4 text-[#c4703f] shrink-0" /><span className="leading-snug">Conciergerie {c}</span></span>
                  <ArrowUpRight className="w-4 h-4 opacity-40 group-hover:opacity-100 shrink-0" />
                </Link>
              </li>
            ))}
          </ul>
          <Link to="/villes" className="mt-4 inline-block text-sm font-bold text-[#c4703f] underline" data-testid="home-all-cities">Voir les 72 communes</Link>
        </Reveal>
      </div>
    </section>
  );
}
